import { useState, useEffect } from "react";

import "./App.css";

import {
  AppUI,
  Base64,
  FaceSDK,
  AsThreshold,
  Template,
  TransactionMode,
} from "@identy/identy-face";
import lamp from "../src/images/lamp.png";
import facial from "../src/images/facial.png";
import faceok from "../src/images/face-ok.png";
import sunglasse from "../src/images/sunglasses.png";

function App({ searchParams }) {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showErrorLinkModal, setShowErrorLinkModal] = useState(false);
  const [showSucessoModal, setShowSucessoModal] = useState(false);
  const [showTraining, setShowTraining] = useState(true);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [countdown, setCountdown] = useState(5);

  const urlBase = process.env.REACT_APP_URL_BASE;
  const urlBaseCRedify = process.env.REACT_APP_URL_BASE_CREDIFY;

  const urlParams = new URLSearchParams(window.location.search);
  const rawToken = window.location.search.match(/[?&]accesskey=([^&]*)/)?.[1];
  const jwtToken = rawToken ? decodeURIComponent(rawToken) : urlParams.get("accesskey");
  const requestID = urlParams.get("requestid");
  const application = urlParams.get("application");
  const wero = urlParams.get("wero");
  const keyUrl = urlParams.get("keyurl");
  console.log(application, wero);

  useEffect(() => {
    let timer;
    if (redirectUrl && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (redirectUrl && countdown === 0) {
      window.location.href = redirectUrl;
    }
    return () => clearTimeout(timer);
  }, [redirectUrl, countdown]);

  FaceSDK.preInitialize(
    {
      URL: `${urlBase}/api/v1/models`,
    },
    {
      URL: {
        url: `${urlBase}/api/v1/pub_key`,
        headers: [
          {
            name: "LogAPITrigger",
            value: "true",
          },
          {
            name: "requestID",
            value: requestID,
          },
        ],
      },
    }
  );

  const runCaptureFace = (transaction) => {
    setShowErrorModal(false);
    setShowErrorLinkModal(false);
    setShowSucessoModal(false);
    setShowTraining(false);
    setShowTimeoutModal(false);
    setShowSpinner(false);
    setRedirectUrl(null);
    setCountdown(5);

    const options = {
      enableAS: true,
      requiredTemplates: [Template.PNG],
      showCaptureTraining: false,
      base64EncodingFlag: Base64.NO_WRAP,
      allowClose: true,
      enableEyesStatusDetector: true,
      skipSupportCheck: false,
      backend: "wasm",
      transaction: {
        type: transaction,
      },
      appUI: AppUI.TICKING,
      allowCameraSelect: false,
      asThreshold: AsThreshold.Medium,
      assisted: false,
      graphics: {
        canvas: {
          label: "white",
          canvasBackground: "white",
          labelBackground: "red",
          ovalBorderBackground: "#c1c1c1",
          ovalBorderErrorBackground: "yellow",
          tickerDefaultBackground: "#c1c1c1",
          tickerActiveBackground: "red",
        },
      },
      localization: {
        en: {
          FEEDBACK_RETRY:
            "Algo está estranho, mova-se um pouco para mudar a iluminação",
          FEEDBACK_RETRY_INSECURE: "Feed da câmera inseguro",
          FEEDBACK_RETRY_QUALITY: "Qualidade ruim, tente novamente",
          FEEDBACK_ENROLLED: "Registrado com sucesso",
          FEEDBACK_CAPTURED: "Capturado com sucesso",
          FEEDBACK_NOT_ENROLLED: "Usuário não registrado",
          FEEDBACK_VERIFY_COMPLETED: "Verificação bem-sucedida",
          FEEDBACK_VERIFY_FAILED: "Falha na verificação",
          FEEDBACK_SEARCHING: "Procurando...",
          FEEDBACK_INSIDE_GUIDE: "Por favor, esteja dentro do guia",
          FEEDBACK_PLEASE_HOLD: "Por favor, aguarde.",
          FEEDBACK_STABLE: "Por favor, permaneça estável",
          FEEDBACK_EYE_LEVEL: "Olhe reto",
          FEEDBACK_UP_FACING: "Olhe para baixo para ficar paralelo à câmera",
          FEEDBACK_DOWN_FACING: "Olhe para cima para ficar paralelo à câmera",
          FEEDBACK_FACE_OUTSIDE: "Por favor, esteja dentro do guia",
          FEEDBACK_CLOSE: "Afaste-se",
          FEEDBACK_FAR: "Aproxime-se",
          FEEDBACK_LEFT_FACING: "Olhando para a esquerda, por favor, olhe reto",
          FEEDBACK_RIGHT_FACING: "Olhando para a direita, por favor, olhe reto",
          FEEDBACK_ROTATED: "Olhe reto",
          FEEDBACK_NOT_STABLE: "Por favor, permaneça estável",
          FEEDBACK_OK: "Por favor, aguarde",
          FEEDBACK_NO: "Verificando",
          FEEDBACK_NOT_CENTERED: "Centralize o rosto no oval",
          FEEDBACK_CAMERA_ACQUIRING_FAILED:
            "Não foi possível acessar a câmera. Conceda permissão ou tente novamente",
          FEEDBACK_PROCESSING: "Processando...",
          FEEDBACK_UPLOAD_FAILURE: "Erro interno, tente novamente",
          FEEDBACK_INITIALIZATION: "Inicializando...",
          FEEDBACK_CHANGE_LIGHT: "Evite sombras",
          FEEDBACK_CHANGE_LIGHT_TOO_BRIGHT:
            "Muito claro, vá para um lugar com melhor iluminação.",
          FEEDBACK_CHANGE_LIGHT_TOO_DARK:
            "Muito escuro, vá para um lugar com melhor iluminação.",
          FEEDBACK_BUTTON_CLOSE: "Fechar",
          FEEDBACK_BUTTON_RETRY: "Tentar novamente",
          FEEDBACK_TRAINING_BUTTON_NEXT: "Próximo",
          FEEDBACK_TRAINING_LABEL: "Não mostrar novamente",
          FEEDBACK_ORIENTATION_NOT_SUPPORTED:
            "Apenas o modo retrato é suportado",
          FEEDBACK_TRAINING_DIALOG_CLOSED: "Diálogo de treinamento encerrado",
          FEEDBACK_LICENCE_INVALID: "Licença inválida!!",
          ERROR_BROWSER_NOT_SUPPORTED:
            "Navegador não suportado. Use Chrome, Firefox, Opera, Edge (iOS, Android, Desktop), Samsung Internet (Android) ou Safari (iOS, MAC)",
          ERROR_BROWSER_VERSION_NOT_SUPPORTED:
            "Versão do navegador não suportada. Atualize para a versão mais recente disponível.",
          ERROR_DEVICE_NOT_SUPPORTED:
            "Dispositivo não suportado. Use um dispositivo móvel ou desktop.",
          ERROR_DEVICE_NOT_SUPPORTED_ANDROID:
            "Versão do Android não suportada. Atualize para a versão mais recente disponível.",
          ERROR_DEVICE_NOT_SUPPORTED_IOS:
            "Versão do iOS não suportada. Atualize para a versão mais recente disponível.",
          ERROR_DEVICE_NOT_SUPPORTED_MEMORY:
            "Dispositivo não suportado. Memória insuficiente.",
          ERROR_PLATFORM_NOT_SUPPORTED_ANDROID:
            "Versão do Android não suportada. Atualize para a versão mais recente disponível.",
          ERROR_PLATFORM_NOT_SUPPORTED_IOS:
            "Versão do iOS não suportada para este navegador. Atualize para a versão mais recente disponível.",
          ERROR_BROWSER_FEATURE_NOT_SUPPORTED:
            "TextDecoder ou API Crypto ausente.",
          ERROR_WEBRTC_NOT_SUPPORTED: "WebRTC não suportado",
          ERROR_MODEL_FAIL: "Falha na detecção do modelo",
          ERROR_SERVER_INTERNAL: "Erro interno do servidor",
          ERROR_SERVER_CONNECTION_FAILURE: "Falha na conexão com o servidor",
        },
      },
    };

    const faceSDK = new FaceSDK(options);

    faceSDK
      .initialize()
      .then(() => {
        console.log("SDK Loaded...");
        faceSDK
          .capture()
          .then((blob) => postData(blob))
          .catch((err) => {
            console.log("catch1");
            console.log(err.code);
            if (err.code === 501) {
              setShowTimeoutModal(true);
            }
            if (err.code === 600) {
            }
            if (err.code === 401) {
              setShowErrorModal(true);
            }
            console.error(err);
          });
      })
      .catch((err) => {
        if (err.code === 501) {
          setShowTimeoutModal(true);
        }
        if (err.code === 600) {
        }
        if (err.code === 401) {
          setShowErrorModal(true);
        }
        console.error(err);
      });
  };

  const postData = (capresult) => {
    if (!jwtToken) {
      setShowSpinner(false);
      setShowErrorLinkModal(true);
      return;
    }
    setShowSpinner(true);
    const fd = new FormData();
    fd.append("file", capresult, `bdata`);

    return fetch(`${urlBaseCRedify}?ts=${new Date().getTime()}`, {
      method: "POST",
      headers: {
        "X-DEBUG": "demo",
        LogAPITrigger: true,
        requestID: requestID,
        application: application,
        wero: wero,
        keyUrl: keyUrl,
        Authorization: `Bearer ${jwtToken}`,
      },
      body: fd,
    })
      .then((response) => {
        return response.json().then((data) => {
          if (!response.ok) {
            const liveliness = data.RESPOSTA && data.RESPOSTA.LIVELINESS;
            let errorMessage = "Erro desconhecido";

            if (liveliness) {
              switch (liveliness.message) {
                case "FEEDBACK_RETRY":
                  errorMessage = "Algo deu errado, tente novamente";
                  break;
                case "FEEDBACK_FAIL":
                  errorMessage = "Falhou, tente novamente";
                  break;
                default:
                  errorMessage = `${liveliness.message}: ${
                    liveliness.description || "Erro desconhecido"
                  }`;
              }
            }
            if (errorMessage === "Erro desconhecido") {
              errorMessage = data.message ? data.message : "Erro desconhecido";
            }

            console.log(`Erro ${response.status}: ${errorMessage}`);
            throw new Error(errorMessage);
          }
          return data;
        });
      })
      .then((data) => {
        console.log(data);
        const liveliness = data.RESPOSTA && data.RESPOSTA.LIVELINESS;
        if (
          liveliness &&
          liveliness.code === 200 &&
          liveliness.message === "FEEDBACK_CAPTURED"
        ) {
          setShowSpinner(false);
          setShowSucessoModal(true);

          const redirectUrlFromResponse = data.RESPOSTA?.URL;
          if (redirectUrlFromResponse) {
            setRedirectUrl(redirectUrlFromResponse);
          }
        } else {
          if (liveliness.message) {
            console.log(liveliness.message);
          } else {
            console.log("Mensagem de erro não disponível.");
          }
          setShowSpinner(false);
          setShowErrorModal(true);
        }
      })
      .catch((err) => {
        console.log("Fetch error:", err);
        if (
          err.message === "Assinatura válida. Token Expirado." ||
          err.message === "Formato de Token Invalido" ||
          err.message ===
            "Assinatura inválida. Token pode ter sido adulterado.." ||
          err.message === "LOGON NAO POSSUI PERMISSAO NA CONSULTA"
        ) {
          setShowSpinner(false);
          setShowErrorLinkModal(true);
        }
        setShowSpinner(false);
        setShowErrorModal(true);
      });
  };

  const handleRetry = () => {
    setShowErrorModal(false);
    runCaptureFace(TransactionMode.capture);
  };

  const handleTimeout = () => {
    setShowTimeoutModal(false);
    runCaptureFace(TransactionMode.capture);
  };

  const handleRedirectNow = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  return (
    <div
      className="App"
      style={{
        backgroundColor: "red",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {showSpinner && (
        <div
          className="spinnerModal"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(255 255 255)",
            color: "#5d5d5d",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div>
            <div className="spinner"></div>
          </div>
        </div>
      )}

      {showErrorModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(244 244 245)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "clamp(12px, 3vw, 20px)",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "500px",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
              padding: "clamp(20px, 5vw, 40px)",
              textAlign: "center",
              border: "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <h1
              style={{
                fontSize: "clamp(22px, 5vw, 28px)",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "clamp(20px, 4vw, 30px)",
                lineHeight: "1.3",
              }}
            >
              Tente outra vez
            </h1>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: "clamp(12px, 3vw, 20px)",
                marginBottom: "clamp(20px, 4vw, 40px)",
              }}
            >
              {[
                {
                  icon: lamp,
                  title: "Iluminação",
                  text: "Procure um local com boa iluminação natural.",
                  bgColor: "#f0f9ff",
                },
                {
                  icon: facial,
                  title: "Posicionamento",
                  text: "Posicione seu rosto dentro do guia exibido na tela.",
                  bgColor: "#f0fdf4",
                },
                {
                  icon: faceok,
                  title: "Expressão",
                  text: "Mantenha a expressão facial neutra.",
                  bgColor: "#fff7ed",
                },
                {
                  icon: sunglasse,
                  title: "Acessórios",
                  text: "Remova acessórios como boné e óculos escuros.",
                  bgColor: "#fef2f2",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    textAlign: "left",
                    gap: "clamp(10px, 3vw, 15px)",
                  }}
                >
                  <div
                    style={{
                      flexShrink: 0,
                      width: "clamp(40px, 8vw, 48px)",
                      height: "clamp(40px, 8vw, 48px)",
                      borderRadius: "12px",
                      backgroundColor: item.bgColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      style={{
                        width: "clamp(18px, 4vw, 24px)",
                      }}
                    />
                  </div>
                  <div>
                    <h3
                      style={{
                        margin: "0 0 4px 0",
                        color: "#2d3748",
                        fontWeight: "500",
                        fontSize: "clamp(14px, 3vw, 16px)",
                      }}
                    >
                      {item.title}
                    </h3>
                    <p
                      style={{
                        margin: 0,
                        color: "#718096",
                        fontSize: "clamp(13px, 3vw, 15px)",
                        lineHeight: "1.4",
                      }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={handleRetry}
              style={{
                width: "100%",
                padding: "clamp(12px, 3vw, 16px)",
                fontSize: "clamp(14px, 3vw, 16px)",
                backgroundColor: "#3b82f6",
                border: "none",
                color: "white",
                borderRadius: "12px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)",
                maxWidth: "300px",
                margin: "0 auto",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#2563eb")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#3b82f6")
              }
            >
              Tentar Novamente
            </button>
          </div>
        </div>
      )}

      {showErrorLinkModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(244 244 245)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "clamp(12px, 3vw, 20px)",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "500px",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
              padding: "clamp(25px, 5vw, 40px)",
              textAlign: "center",
              border: "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                width: "clamp(60px, 12vw, 80px)",
                height: "clamp(60px, 12vw, 80px)",
                backgroundColor: "#fee2e2",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto clamp(20px, 4vw, 30px)",
                color: "#dc2626",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="clamp(30px, 6vw, 40px)"
                height="clamp(30px, 6vw, 40px)"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>

            <h1
              style={{
                fontSize: "clamp(22px, 5vw, 28px)",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "clamp(8px, 2vw, 12px)",
                lineHeight: "1.3",
              }}
            >
              Link Expirado
            </h1>

            <p
              style={{
                fontSize: "clamp(15px, 3vw, 17px)",
                color: "#71717a",
                margin: 0,
                lineHeight: "1.5",
                maxWidth: "400px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              Este link de captura facial não é mais válido.
            </p>
          </div>
        </div>
      )}

      {showTimeoutModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(244 244 245)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "16px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "500px",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
              padding: "clamp(20px, 5vw, 40px)",
              textAlign: "center",
              border: "1px solid rgba(0, 0, 0, 0.05)",
              margin: "0 16px",
            }}
          >
            <h1
              style={{
                fontSize: "clamp(22px, 5vw, 28px)",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "clamp(20px, 4vw, 30px)",
                lineHeight: "1.3",
              }}
            >
              Seu tempo acabou
              <div
                style={{
                  fontSize: "clamp(16px, 3vw, 18px)",
                  fontWeight: "normal",
                  color: "#718096",
                  marginTop: "8px",
                }}
              >
                Vamos tentar novamente?
              </div>
            </h1>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: "clamp(12px, 3vw, 20px)",
                marginBottom: "clamp(20px, 4vw, 40px)",
              }}
            >
              {[
                {
                  icon: lamp,
                  title: "Iluminação",
                  text: "Procure um local com boa iluminação natural.",
                  bgColor: "#f0f9ff",
                },
                {
                  icon: facial,
                  title: "Posicionamento",
                  text: "Centralize seu rosto dentro do guia na tela.",
                  bgColor: "#f0fdf4",
                },
                {
                  icon: faceok,
                  title: "Expressão",
                  text: "Mantenha uma expressão facial neutra.",
                  bgColor: "#fff7ed",
                },
                {
                  icon: sunglasse,
                  title: "Acessórios",
                  text: "Remova óculos escuros, bonés ou qualquer obstrução.",
                  bgColor: "#fef2f2",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    textAlign: "left",
                    gap: "clamp(10px, 3vw, 15px)",
                  }}
                >
                  <div
                    style={{
                      flexShrink: 0,
                      width: "clamp(40px, 8vw, 48px)",
                      height: "clamp(40px, 8vw, 48px)",
                      borderRadius: "12px",
                      backgroundColor: item.bgColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      style={{
                        width: "clamp(18px, 4vw, 24px)",
                      }}
                    />
                  </div>
                  <div>
                    <h3
                      style={{
                        margin: "0 0 4px 0",
                        color: "#2d3748",
                        fontWeight: "500",
                        fontSize: "clamp(14px, 3vw, 16px)",
                      }}
                    >
                      {item.title}
                    </h3>
                    <p
                      style={{
                        margin: 0,
                        color: "#718096",
                        fontSize: "clamp(13px, 3vw, 15px)",
                        lineHeight: "1.4",
                      }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={handleTimeout}
              style={{
                width: "100%",
                padding: "clamp(12px, 3vw, 16px)",
                fontSize: "clamp(14px, 3vw, 16px)",
                backgroundColor: "#3b82f6",
                border: "none",
                color: "white",
                borderRadius: "12px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)",
                maxWidth: "300px",
                margin: "0 auto",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#2563eb")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#3b82f6")
              }
            >
              Tentar Novamente
            </button>
          </div>
        </div>
      )}

      {showSucessoModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(244 244 245)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "clamp(12px, 3vw, 20px)",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "500px",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
              padding: "clamp(25px, 5vw, 40px)",
              textAlign: "center",
              border: "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                width: "clamp(60px, 12vw, 80px)",
                height: "clamp(60px, 12vw, 80px)",
                backgroundColor: "#ecfdf5",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto clamp(20px, 4vw, 30px)",
                color: "#10b981",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="clamp(30px, 6vw, 40px)"
                height="clamp(30px, 6vw, 40px)"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>

            <h1
              style={{
                fontSize: "clamp(22px, 5vw, 28px)",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "clamp(8px, 2vw, 12px)",
                lineHeight: "1.3",
              }}
            >
              Captura realizada com sucesso!
            </h1>

            {redirectUrl && (
              <div
                style={{
                  backgroundColor: "#f0f9ff",
                  border: "1px solid #bae6fd",
                  borderRadius: "12px",
                  padding: "clamp(16px, 3vw, 20px)",
                  margin: "clamp(16px, 3vw, 24px) 0",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "24px",
                      height: "24px",
                      backgroundColor: "#0ea5e9",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    ⏱
                  </div>
                  <span
                    style={{
                      fontSize: "clamp(15px, 3vw, 17px)",
                      fontWeight: "500",
                      color: "#0369a1",
                    }}
                  >
                    Redirecionando automaticamente...
                  </span>
                </div>

                <div
                  style={{
                    fontSize: "clamp(14px, 3vw, 16px)",
                    color: "#475569",
                    lineHeight: "1.5",
                  }}
                >
                  <p style={{ margin: "0 0 8px 0" }}>
                    Você será redirecionado em{" "}
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#0ea5e9",
                        fontSize: "clamp(16px, 3vw, 18px)",
                      }}
                    >
                      {countdown} segundos
                    </span>
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "clamp(13px, 3vw, 14px)",
                      opacity: 0.8,
                    }}
                  >
                    Aguarde ou clique no botão abaixo para ser direcionado
                    automaticamente
                  </p>
                </div>
              </div>
            )}

            <p
              style={{
                fontSize: "clamp(15px, 3vw, 17px)",
                color: "#71717a",
                margin: "0 auto",
                lineHeight: "1.5",
                maxWidth: "400px",
                marginBottom: "clamp(16px, 3vw, 24px)",
              }}
            >
              Sua captura facial foi processada com sucesso e está pronta para
              uso.
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                alignItems: "center",
              }}
            >
              {keyUrl && redirectUrl ? (
                <button
                  onClick={handleRedirectNow}
                  style={{
                    padding: "clamp(12px, 3vw, 16px) clamp(20px, 4vw, 24px)",
                    fontSize: "clamp(14px, 3vw, 16px)",
                    backgroundColor: "#0ea5e9",
                    border: "none",
                    color: "white",
                    borderRadius: "12px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)",
                    textDecoration: "none",
                    width: "100%",
                    maxWidth: "280px",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0284c7")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0ea5e9")
                  }
                >
                  ↳ Ir Agora
                </button>
              ) : (
                <button
                  onClick={() => window.close()}
                  style={{
                    padding: "clamp(12px, 3vw, 16px) clamp(20px, 4vw, 24px)",
                    fontSize: "clamp(14px, 3vw, 16px)",
                    backgroundColor: "#6b7280",
                    border: "none",
                    color: "white",
                    borderRadius: "12px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 6px rgba(107, 114, 128, 0.2)",
                    width: "100%",
                    maxWidth: "280px",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#4b5563")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#6b7280")
                  }
                >
                  Fechar
                </button>
              )}

              {wero && (
                <button
                  onClick={() => {
                    const baseUrl = "https://dev-app.decisionfy.credify.com.br";
                    const searchParams = new URLSearchParams(
                      window.location.search
                    );
                    const requestId = searchParams.get("requestid");
                    if (requestId)
                      window.location.href = `${baseUrl}/kyc/wero/result-prestador?requestid=${requestId}`;
                    else console.error("requestid parameter not found in URL");
                  }}
                  style={{
                    padding: "clamp(12px, 3vw, 16px) clamp(20px, 4vw, 24px)",
                    fontSize: "clamp(14px, 3vw, 16px)",
                    backgroundColor: "#3b82f6",
                    border: "none",
                    color: "white",
                    borderRadius: "12px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)",
                    textDecoration: "none",
                    width: "100%",
                    maxWidth: "280px",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#2563eb")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#3b82f6")
                  }
                >
                  Ver Resultado
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {showTraining && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(244 244 245)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "clamp(12px, 3vw, 20px)",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              maxWidth: "500px",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
              padding: "clamp(20px, 5vw, 40px)",
              textAlign: "center",
              border: "1px solid rgba(0, 0, 0, 0.05)",
              margin: "0 clamp(10px, 3vw, 16px)",
            }}
          >
            <h1
              style={{
                fontSize: "clamp(22px, 5vw, 28px)",
                fontWeight: "600",
                color: "#2d3748",
                marginBottom: "clamp(20px, 4vw, 30px)",
                lineHeight: "1.3",
              }}
            >
              Vamos Começar a Captura Facial
            </h1>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: "clamp(12px, 3vw, 20px)",
                marginBottom: "clamp(20px, 4vw, 40px)",
              }}
            >
              {[
                {
                  icon: lamp,
                  title: "Iluminação",
                  text: "Procure um local com boa iluminação natural.",
                  bgColor: "#f0f9ff",
                },
                {
                  icon: facial,
                  title: "Posicionamento",
                  text: "Centralize seu rosto dentro do guia na tela.",
                  bgColor: "#f0fdf4",
                },
                {
                  icon: faceok,
                  title: "Expressão",
                  text: "Mantenha uma expressão facial neutra e relaxada.",
                  bgColor: "#fff7ed",
                },
                {
                  icon: sunglasse,
                  title: "Acessórios",
                  text: "Remova óculos escuros, bonés ou qualquer obstrução.",
                  bgColor: "#fef2f2",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    textAlign: "left",
                    gap: "clamp(10px, 3vw, 15px)",
                  }}
                >
                  <div
                    style={{
                      flexShrink: 0,
                      width: "clamp(40px, 8vw, 48px)",
                      height: "clamp(40px, 8vw, 48px)",
                      borderRadius: "12px",
                      backgroundColor: item.bgColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={item.title}
                      style={{
                        width: "clamp(18px, 4vw, 24px)",
                      }}
                    />
                  </div>
                  <div>
                    <h3
                      style={{
                        margin: "0 0 4px 0",
                        color: "#2d3748",
                        fontWeight: "500",
                        fontSize: "clamp(14px, 3vw, 16px)",
                      }}
                    >
                      {item.title}
                    </h3>
                    <p
                      style={{
                        margin: 0,
                        color: "#718096",
                        fontSize: "clamp(13px, 3vw, 15px)",
                        lineHeight: "1.4",
                      }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => runCaptureFace(TransactionMode.capture)}
              style={{
                width: "100%",
                padding: "clamp(12px, 3vw, 16px)",
                fontSize: "clamp(14px, 3vw, 16px)",
                backgroundColor: "#3b82f6",
                border: "none",
                color: "white",
                borderRadius: "12px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)",
                maxWidth: "300px",
                margin: "0 auto",
                marginTop: "clamp(10px, 2vw, 20px)",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#2563eb")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#3b82f6")
              }
            >
              Iniciar Captura
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
